import UserApi from "./user_api";
import OrderApi from "./order_api";
import AddressApi from "./address_api";
import AuthApi from "./auth_api";
import BannerApi from "./banner_api";
import DocumentApi from "./document_api";
import EmployeeApi from "./employee_api";
import ReportApi from "./report_api";
import TopupApi from "./topup"
import WebHookApi from "./webhook_api"
import CreditApi from './credit_api'

export const UserService = new UserApi();
export const OrderService = new OrderApi();
export const AddressService = new AddressApi();
export const AuthService = new AuthApi();
export const BannerService = new BannerApi();
export const DocumentService = new DocumentApi();
export const EmployeeService = new EmployeeApi();
export const ReportService = new ReportApi();
export const TopupService = new TopupApi();
export const WebHookService = new WebHookApi()
export const CreditService = new CreditApi()